<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="700XAuto"
      :loading="loading"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      not-footer-padding
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      <template v-if="opType === OpEnum.type.ADD">添加ASIN</template>
      <template v-if="opType === OpEnum.type.UPDATE">关键词维护</template>
    </template>
    <template #content>
      <el-form
          ref="form"
          :model="form"
          label-width="60px">
        <el-form-item
            label="名称"
            prop="name"
            :rules="[
              { required: true, message: '请输入名称', trigger: ['change'] }
            ]">
          <gj-input
              v-model="form.name"
              width="100%"
              :disabled="opType === OpEnum.type.UPDATE"
              placeholder="请输入名称"
          ></gj-input>
        </el-form-item>
        <el-form-item
            label="ASIN"
            prop="asin"
            :rules="[
              { required: true, message: '请输入ASIN!', trigger: ['change'] },
            ]"
            class="asin-control"
            :class="{'asin-message': ASINMessage}">
          <div class="asin-content">
            <el-radio-group v-model="form.parentAsin" :disabled="opType === OpEnum.type.UPDATE" @change="asinBlur()">
              <el-radio :label="true">父</el-radio>
              <el-radio :label="false">子</el-radio>
            </el-radio-group>
            <gj-input
                v-model="form.asin"
                width="200px"
                :disabled="opType === OpEnum.type.UPDATE"
                placeholder="请输入ASIN"
                @input="asinInput()"
                @blur="asinBlur()">
            </gj-input>
            <div class="asin-message" v-if="form.asin">{{ ASINMessage === 'cancelToken' ? '' : ASINMessage }}</div>
            <div class="asin-message-sign">父ASIN只能添加已授权店铺下商品，子ASIN支持竞品，请正确选择以获取排名</div>
          </div>
        </el-form-item>
        <el-form-item
            label="国家"
            prop="countryCode"
            :rules="[
              { required: true, message: '请选择国家', trigger: ['change'] }
            ]">
          <gj-select
              v-model="form.countryCode"
              :options="KeywordRankEnum.countryOption"
              :disabled="opType === OpEnum.type.UPDATE"
              placeholder="请选择国家"
              width="100%">
          </gj-select>
        </el-form-item>
        <el-form-item
            label="关键词"
            prop="keywordText"
            :rules="[
              { required: true, message: '请输入关键词', trigger: ['change'] }
            ]">
          <gj-textarea
              v-model="form.keywordText"
              :styles="{height: '120px', width: '100%'}"
              placeholder="回车输入多个关键词">
          </gj-textarea>
        </el-form-item>
        <el-form-item style="margin-bottom: 0;">
          <gj-alert
              border type="info" show-icon
              :style="{width: '100%'}">
            <div style="line-height: normal">
              您已添加 <span style="color: red;">{{addKeywordNum}}</span> 关键词，还可添加 <span style="color: red;">{{allowKeywordNum}}</span> 关键词！如需增加请联系客服升级套餐！！
            </div>
          </gj-alert>
        </el-form-item>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import { formRuleMixin, modalMixIn, opTypeMixin, responseMixin } from "@/minxins";
  import { addAdKeywordRank, getAdsKeywordQuantity, getAdsLocationGroup, updateAdKeywordRank, keywordRank } from "@/api/ad";
  import { splitAndUnique } from "@/utils/common";
  import { OpEnum } from "@/utils/options";
  import { KeywordRankEnum } from "modules/common/ad/rank/keyword-rank/enum";
  export default {
    name: "app-asin-monitor-op-modal",
    mixins: [modalMixIn, formRuleMixin, responseMixin, opTypeMixin],
    props: {
      keyword: null,
    },
    data() {
      return {
        OpEnum,
        KeywordRankEnum,
        allKeywordNum: null,
        alreadyKeywordNum: null,
        loading: false,
        isAsinLoading: false,
        ASINMessage: null, // ASIN格式错误！ 已授权店铺下无该父ASIN！
        form: {
          asin: null,
          countryCode: null,
          parentAsin: false,
          name: null,
          keywordText: '',
        },
      }
    },
    created() {
      if (this.editOpType) {
        this.loading = true;
        Promise.all([getAdsLocationGroup(this.keyword.id), getAdsKeywordQuantity()])
          .then(([adsRankGroup, qtyObj]) => {
            // 关键词词组
            Object.assign(this.form, adsRankGroup);
            this.form.keywordText = adsRankGroup.keywordList.join('\n');
            // 关键词数量
            this.alreadyKeywordNum = qtyObj.addedQuantity-this.keywordList.length;
            this.allKeywordNum = qtyObj.canAddQuantity + qtyObj.addedQuantity;
          })
          .complete(() => this.loading = false);
      } else if (this.addOpType) {
        this.loading = true;
        getAdsKeywordQuantity()
          .then(qtyObj => {
            this.alreadyKeywordNum = qtyObj.addedQuantity;
            this.allKeywordNum = qtyObj.canAddQuantity + qtyObj.addedQuantity;
          })
          .complete(() => this.loading = false);
      }
    },
    computed: {
      keywordList() {
        return splitAndUnique(this.form.keywordText);
      },
      addKeywordNum() {
        return this.alreadyKeywordNum>=0
          ? this.alreadyKeywordNum + this.keywordList.length
          : 0;
      },
      allowKeywordNum() {
        return this.allKeywordNum
          ? this.allKeywordNum - this.addKeywordNum
          : 0;
      }
    },
    methods: {
      async confirm() {
        await this.asinBlur()
        if (this.ASINMessage) return false
        if (this.$gjFormValidate()) {
          if (this.addOpType) {
            this.confirmLoading = true;
            addAdKeywordRank({
              asin: this.form.asin,
              countryCode: this.form.countryCode,
              name: this.form.name,
              parentAsin: this.form.parentAsin,
              keywordList: this.keywordList
            })
              .then((res) => {
                this.$gjResponseHandle(res, () => {
                  this.$gjMessage.success('添加成功');
                  this.$emit('created');
                  this.$gjDestroy();
                });
              })
              .complete(() => this.confirmLoading = false);
          } else if (this.editOpType) {
            this.confirmLoading = true;
            updateAdKeywordRank({
              id: this.keyword.id,
              keywordList: this.keywordList
            })
              .then((res) => {
                this.$gjResponseHandle(res, () => {
                  this.$gjMessage.success('更新成功');
                  this.$emit('updated');
                  this.$gjDestroy();
                });
              })
              .complete(() => this.confirmLoading = false);
          }
        }
      },
      asinInput() {
        this.ASINMessage = null
      },
      // 校验父asin是否属于自己
      async asinBlur() {
        if (!this.form.asin) return false 
        this.isAsinLoading = true
        let params = {
          parentAsin: this.form.parentAsin,
          asin: this.form.asin,
        }
        try {
          let { code } = await keywordRank.checkAsin(params)
          code === 0 &&  (this.ASINMessage = null) 
        } catch (error) {
          this.ASINMessage = error.message
        } finally {
          this.isAsinLoading = false
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  /deep/ .el-alert__icon.is-big {
    font-size: 16px;
    width: 16px;
  }
  .asin-control {
    margin-bottom: 30px;
    &.asin-message {
      /deep/.el-input__inner {
            border-color: #F5222D !important;
      }
    }
    .asin-content {
      display: flex;
      align-items: center;
      position: relative;
      .asin-message {
        transform: translate(9px, 0);
        color: #F5222D;
      }
      .asin-message-sign {
        line-height: 1;
        position: absolute;
        left: 0;
        bottom: -20px;
        color: #999;
      }
      /deep/.el-radio {
        margin-right: 15px;
      }
    }
    /deep/ .el-form-item__error {
      left: 306px;
      top: 18px;
    }
  }
</style>

